import React, { useState, useEffect } from "react";

import { fetchCategories, saveCategories } from "./api";
import CategoryEditor from "./category-editor";
import BackArrow from "./back-arrow";
import { useAppContext } from "./app-context";

import styles from "./categories.module.css";

export default () => {
    const { categoriesQuery: {
        data: categories,
        refetch: refetchCategories
    }, spaceScopedFetch } = useAppContext();

    return (
        <div className={styles.root}>
            <h1><BackArrow /><span className="material-symbols-outlined">label</span><span>Categories</span></h1>
            <p>Here you can edit the categories used to categorize your transactions.</p>
            <CategoryEditor
                categories={categories}
                onCategoriesChanged={async c => {
                    await saveCategories(c, spaceScopedFetch);
                    refetchCategories();
                }}
            />
        </div>
    );
}
